import { createContext } from 'react';
import Loading from '../components/loading/index.js';
const LoadingComponent = createContext(Loading);
export default LoadingComponent;
//# sourceMappingURL=loading-component.js.map